import { Component, HostListener, ViewEncapsulation, input, output, inject } from '@angular/core';
import { toArray } from 'rxjs/operators';
import { NgClass } from '@angular/common';

import { ApFileReaderService } from '../fileReader.service';

import { ReadFile } from './../read-file.model';

/**
 * @ngdoc component
 * @name ApDropzoneComponent
 */
@Component({
    selector: 'ap-dropzone',
    templateUrl: './dropzone.component.html',
    styleUrls: ['./dropzone.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgClass],
    providers: [ApFileReaderService]
})
export class ApDropzoneComponent {
    fileReaderService = inject(ApFileReaderService);

    /**
     *  Flag which decides if the dropzone should be disabled
     */
    public readonly isDisabled = input(false);

    /**
     *  Flag which decides if maximum amount of files is reached
     */
    public readonly maximumFilesReached = input(false);

    /**
     *  Emits event if file is dropped in the dropzone
     */
    public readonly fileDropped = output<ReadFile[]>();

    public showErrorStyling = false;

    @HostListener('dragover', ['$event'])
    public onDragover(event: Event) {
        event.stopPropagation();
        event.preventDefault();
    }

    @HostListener('drop', ['$event'])
    public onDrop(event: any) {
        event.stopPropagation();
        event.preventDefault();
        this.showErrorStyling = false;

        if (!this.isDisabled()) {
            const file$ = this.fileReaderService.readFilesParallel(event.dataTransfer.files);
            file$.pipe(toArray()).subscribe((readFile) => this.fileDropped.emit(readFile));
        }
    }

    public onDragleave(event: Event) {
        this.showErrorStyling = false;
        event.stopPropagation();
        event.preventDefault();
    }

    public onDragenter() {
        if (this.maximumFilesReached()) {
            this.showErrorStyling = true;
        }
    }
}
